<template>
  <div class="component">
    <transition enter-active-class="fade-in-up">
      <div class="container px-xs-sm-2" v-if="inview">
        <div class="row">
          <div class="col-md-6 order-md-2">
            <div v-if="this.$root.browser !== 'is-ie'" class="animation">
              <animation v-bind:animation="animation"></animation>
            </div>
            <figure v-else>
              <img
                class="img-fluid"
                src="@/assets/images/illustration-ventilation.svg"
              />
            </figure>
          </div>
          <div class="col-md-6 col-xl-5 offset-xl-1 order-md-1">
            <div class="headings pt-6 pt-md-0">
              <eyebrow-icon
                v-if="eyebrowicon"
                v-bind:eyebrowicon="eyebrowicon"
              ></eyebrow-icon>
              <div class="title">
                <h5>{{ name }}</h5>
              </div>
              <h1 v-html="headline"></h1>
              <a
                v-bind:href="cta.href"
                class="btn"
                v-bind:target="cta.target"
                v-bind:class="{
                  'cta-plain text-red icon right-arrow': cta.style === 'text',
                  'cta-pill filled-red icon right-arrow': cta.style === 'pill',
                }"
                >{{ cta.text }}</a
              >
            </div>
          </div>
        </div>

        <div class="row content offset-xl-1">
          <div class="col-md-4 mb-4 mb-md-0" v-for="item in items">
            <eyebrow-icon
              v-if="item.eyebrowicon"
              v-bind:eyebrowicon="item.eyebrowicon"
            ></eyebrow-icon>
            <h5>{{ item.title }}</h5>
            <p class="d-none d-md-block">{{ item.description }}</p>
            <a
              v-bind:href="item.href"
              class="btn"
              v-bind:target="item.target[0]"
              v-bind:class="{
                'cta-plain text-red icon right-arrow': item.style === 'text',
                'cta-pill filled-red icon right-arrow': item.style === 'pill',
              }"
              >{{ item.cta }}</a
            >
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import inview from "../../mixins/inview";

export default {
  name: "ventilation-solutions",
  props: ["name", "headline", "cta", "animation", "eyebrowicon", "items"],
  mixins: [inview],
};
</script>

<style lang="scss" scoped>
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";

.title {
  margin-bottom: 0.5rem;
  @extend %body-normal-bold;
}

h5 {
  position: relative;
  margin-bottom: 0.25rem;

  &:before {
    content: "";
    position: absolute;
    top: -1rem;
    left: 0;
    width: 1.25rem;
    height: 3px;
    background-color: $cc-resmed-black;
  }

  @media (min-width: 768px) {
    margin-bottom: 0.75rem;
  }

  @media (min-width: 992px) {
    min-height: 0;
  }
}

.content {
  h5 {
    &:before {
      display: none;

      @media (min-width: 768px) {
        display: block;
      }
    }
  }
}

.animation {
  transform: scale(1.3) translateY(1rem);

  @media (min-width: 768px) {
    transform: scale(1.475) translateY(1rem) translateX(-1rem);
  }

  @media (min-width: 992px) {
    transform: scale(1.35);
  }

  @media (min-width: 1200px) {
    transform: scale(1.5) translateX(2rem);
  }
}

.headings {
  @media (min-width: 1200px) {
    transform: translateY(1rem);
  }
}

.content {
  padding-top: 4rem;

  @media (min-width: 768px) {
    padding-top: 6rem;

    .btn {
      position: absolute;
      bottom: 0;
    }
  }

  @media (min-width: 992px) {
    padding-top: 7rem;
  }

  @media (min-width: 1200px) {
    padding-top: 9rem;
  }

  p {
    margin: 0;
    padding-bottom: 2.25rem;

    @media (min-width: 992px) {
      padding: 0 2rem 2.25rem 0;
    }

    @media (min-width: 1200px) {
      padding: 0 4rem 2.25rem 0;
    }
  }
}
</style>

<style lang="scss">
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";

// --> /deep/ no longer works
.ventilation-solutions .headings {
  h1 {
    @extend %display;
    margin-bottom: 1.75rem;
    transform: translateX(-5px);

    span {
      color: $cc-resmed-action-red;
    }
  }
}
</style>